import axios from 'axios';

interface ApiErrorPayload {
  message?: unknown;
  errors?: unknown;
}

export function getApiErrorMessage(error: unknown, fallback: string): string {
  if (axios.isAxiosError<unknown>(error)) {
    if (!error.response || error.response.status >= 500) return fallback;
    const data = error.response.data;
    if (typeof data === 'string') {
      const text = data.trim();
      return text && text.length <= 1000 && !/<\/?[a-z][^>]*>/i.test(text) ? text : fallback;
    }
    const payload = data && typeof data === 'object' ? data as ApiErrorPayload : {};
    const message = payload.message;
    const summary = typeof message === 'string' && message.trim() ? message.trim() : '';
    const errors = payload.errors;
    if (Array.isArray(errors) || errors && typeof errors === 'object') {
      const values = Array.isArray(errors) ? errors : Object.values(errors).flat();
      const messages = values.map(item => item && typeof item === 'object' && 'message' in item ? item.message : item)
        .filter((item): item is string => typeof item === 'string' && Boolean(item.trim()));
      if (messages.length) return [...new Set(messages)].join(', ');
    }
    return summary || fallback;
  }

  return error instanceof Error && error.message ? error.message : fallback;
}
